/**
 * [PORTABLE] UI-only state for the Onboarding feature.
 * Target path in main project: src/features/onboarding/store/onboarding-ui-store.ts
 * Dependencies: zustand
 */
import { create } from "zustand";
import type { Pillar } from "../types/onboarding.types";

type GenerationByPillar = Record<Pillar, string | null>;
const EMPTY_GEN: GenerationByPillar = { selfie: null, image: null, video: null };

interface OnboardingUiState {
  selectedPillar: Pillar;
  selectedLevelId: string | null;
  isUploadModalOpen: boolean;
  isPromptModalOpen: boolean;
  activeGenerationIdByPillar: GenerationByPillar;
  selectedSelfieLibraryItemId: string | null;

  setSelectedPillar: (pillar: Pillar) => void;
  setSelectedLevelId: (id: string | null) => void;
  openUploadModal: () => void;
  closeUploadModal: () => void;
  openPromptModal: (levelId: string) => void;
  closePromptModal: () => void;
  setActiveGenerationId: (pillar: Pillar, id: string | null) => void;
  setSelectedSelfieLibraryItemId: (id: string | null) => void;
  reset: () => void;
}

export const useOnboardingUiStore = create<OnboardingUiState>((set) => ({
  selectedPillar: "selfie",
  selectedLevelId: null,
  isUploadModalOpen: false,
  isPromptModalOpen: false,
  activeGenerationIdByPillar: { ...EMPTY_GEN },
  selectedSelfieLibraryItemId: null,

  setSelectedPillar: (selectedPillar) => set({ selectedPillar }),
  setSelectedLevelId: (selectedLevelId) => set({ selectedLevelId }),
  openUploadModal: () => set({ isUploadModalOpen: true }),
  closeUploadModal: () => set({ isUploadModalOpen: false }),
  openPromptModal: (levelId) => set({ isPromptModalOpen: true, selectedLevelId: levelId }),
  closePromptModal: () => set({ isPromptModalOpen: false }),
  setActiveGenerationId: (pillar, id) =>
    set((s) => ({
      activeGenerationIdByPillar: { ...s.activeGenerationIdByPillar, [pillar]: id },
    })),
  setSelectedSelfieLibraryItemId: (selectedSelfieLibraryItemId) =>
    set({ selectedSelfieLibraryItemId }),
  reset: () =>
    set({
      selectedLevelId: null,
      isUploadModalOpen: false,
      isPromptModalOpen: false,
      activeGenerationIdByPillar: { ...EMPTY_GEN },
    }),
}));